import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Divider, FormHelperText } from "@mui/material";
import { connect } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import "../../Orders/order.css";
import GiftField from "./GiftField";
import Notification from "../../../components/Common/Notification";
import Helpers from "../../../helpers/helpers";

const Gift = ({ setFormValues, values, error, productListing, setSelectedGiftItem }) => {
  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });
  const [tempProduct, setTempProduct] = useState({
    product_id: "",
    gift_product_name: "",
    gift_category_names: "",
    gift_aspeed_price: "",
  })

  const [tempGiftEmpty, setTempGiftEmpty] = useState([])
  const [data, setData] = useState(values?.product_gifts)
  const [giftList, setGiftList] = useState(productListing)

  useEffect(() => {
    if (values?.product_gifts?.length > 0) {
      handleCheckDuplicate("Add")
    } else
      setGiftList(productListing)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productListing, values?.product_gifts]);

  useEffect(() => {
    setData(values?.product_gifts)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ values?.product_gifts]);

  const handleCheckDuplicate = (type, addedGift) => {
    let tempAccessoriesData = values?.product_gifts
    if (type === "Add") {
      if (tempAccessoriesData?.length > 0) {
        const usedCategoryIds = tempAccessoriesData?.length > 0 && tempAccessoriesData?.map(item => item.gift_id);
        const newFilteredCat = productListing?.length > 0 && productListing.filter(cat => !usedCategoryIds?.includes(cat.id));
        setGiftList(newFilteredCat || [])
      }
    } else if (type === "Delete") {
      const usedCategoryIds = addedGift?.length > 0 && addedGift?.map(item => item.gift_id);
      const newFilteredCat = usedCategoryIds?.length > 0 ? productListing?.length > 0 && productListing.filter(cat => !usedCategoryIds?.includes(cat.id)) : productListing;
      setGiftList(newFilteredCat || [])
    }
  }

  const handleAddProduct = () => {
    let temp = values?.product_gifts || []
    if (tempProduct?.product_id) {
      const selectedProduct = productListing && productListing?.length > 0 && productListing.find(
        (product) => product.id === tempProduct?.product_id || product.value === tempProduct?.product_id
      );
      temp?.push({
        gift_id: selectedProduct?.id,
        gift_product_name: selectedProduct?.name,
        gift_aspeed_price: selectedProduct?.aspeed_price,
        gift_category_names: selectedProduct?.categories,
      })
      setFormValues((prevValue) => ({
        ...prevValue, // Keep the previous values for all other properties
        product_gifts: temp,
      }));

      setTempProduct("")
      setData(temp)
    } else {
      setNotification({
        open: true,
        msg: "Please complete gift section!",
        type: "warning",
      })
    }
    handleCheckDuplicate("Add", null)

  }

  const handleDeleteGift = (idx) => {
    let temp = values?.product_gifts?.filter((_, index) => index !== idx)
    setFormValues((prevValue) => ({
      ...prevValue,
      product_gifts: temp,
    }));
    setData(temp)
    handleCheckDuplicate("Delete", temp)
  }


  return (
    <React.Fragment>
      <Notification notification={notification} setNotification={setNotification} />
      <Card className="p-3 px-2" style={{ minHeight: "40vh" }}>
        <CardBody>
          <div className="setting-header">GIFTS</div>
          {error && <FormHelperText sx={{ color: "red" }}>{error && Helpers?.getCustomErrorMessageByPrefix(error, "product_gifts.")}</FormHelperText>}
          <Divider className="my-2 mb-4" />
          <GiftField
            data={data}
            setData={setData}
            tempGiftEmpty={tempGiftEmpty}
            setTempGiftEmpty={setTempGiftEmpty}
            productListing={giftList}
            tempGift={values?.product_gifts}
            error={error}
            handleDeleteGift={handleDeleteGift}
            setTempGift={setFormValues}
            setTempProduct={setTempProduct}
            tempProduct={tempProduct}
            handleAddProduct={handleAddProduct}
          />
        </CardBody>
      </Card>
    </React.Fragment >
  );
};

function mapStateToProps({ }) {
  return {

  };
}


export default connect(mapStateToProps)(Gift);
